const INITIAL_STATE = {
	registro: {},
	modoTela: 'trilha',
	aguardando: false,
	lista: [],
	listaUsuario: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'INCUBACAO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'INCUBACAO_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

        case 'INCUBACAO_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

		case 'INCUBACAO_USUARIO_SELECT_LISTADO':
            return {
				...state,
				listaUsuario: action.payload.data.filter(item => !item.administrador)
			};

        default:
            return state;
    }
}
